export default {
  create: {
    title: 'Agregar',
    subtitle: 'Juegos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Juego',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Loop',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Loop',
    actions: 'Acciones',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
  },
  form: {
    name: {
      label: 'Nombre:',
      placeholder: 'Ej: Loop Nivel 1',
      invalid: 'El nombre es obligatorio',
    },
    showAnswer: {
      label: 'Mostrar respuesta',
    },
    colored: {
      label: 'Colorido',
    },
    columns: {
      label: 'Columnas:',
    },
    rows: {
      label: 'Filas:',
    },
    numObstacles: {
      label: 'Cantidad de obstáculos:',
      auto: 'Automático',
      tooltipAuto: 'Sugerencia ideal: {count} obstáculos para esta cuadrícula.',
      tooltipManual: 'Defina la cantidad de obstáculos manualmente.',
      parityHint:
        'Para este tamaño de cuadrícula, use un número {parity} de obstáculos.',
      parityOdd: 'impar',
      parityEven: 'par',
    },
    pathWeight: {
      label: 'Grosor de las líneas:',
      thin: 'Fina',
      normal: 'Normal',
      bold: 'Gruesa',
    },
    prioritizeQuality: {
      label: 'Calidad visual',
      enabled: 'Activado',
      tooltip:
        'Genera varias opciones y elige la que tiene la mejor distribución en la cuadrícula. Puede tardar más tiempo.',
    },
    fastGeneration: {
      label: 'Generación rápida',
      enabled: 'Activado',
      tooltipLarge:
        'Activado automáticamente: Las cuadrículas mayores que 8x8 exigen este algoritmo optimizado para generar al instante y evitar bloqueos.',
      tooltip:
        'Usa un algoritmo optimizado para generar al instante. Tiene un patrón más geométrico.',
    },
  },
  button: {
    generate: 'Generar juego',
  },
  sidebar: {
    exportHint: 'Debe guardar antes de exportar.',
    defaultFileName: 'puzzle-loop',
  },
  alert: {
    firstLoopFound: '¡Primer Loop encontrado!',
    perfectLoopFound: '¡Loop perfecto encontrado!',
    bestOptionFound: '¡Mejor opción encontrada!',
    generateFailed:
      'No fue posible generar un loop cerrado. Intente cambiar los obstáculos.',
    workerError: 'Error en el worker {index}: {message}',
    workerCritical: 'Fallo crítico en un Worker.',
    gameSaved: '¡Juego guardado con éxito!',
    workerErrors: {
      invalidParity: 'Paridad incorrecta para el tamaño de la cuadrícula.',
      noUniqueSolution:
        'No fue posible encontrar una solución única tras el límite de intentos.',
    },
  },
};
